import { IBaseFormFieldProps } from './types';

export const defaultProps: Partial<IBaseFormFieldProps> = {
    orientation: 'vertical',
    gap: '5'
};
